module.exports = __webpack_public_path__ + "img/Hidden-Number-2.9ea1ece1.svg";